import { cva } from 'class-variance-authority'

import { cn } from '@/lib/ui/style-helpers'

export const toolbarButtonVariant = cva(
  cn(
    '!flex !size-8 !items-center !justify-center !self-center !border !border-solid !border-main-border-semiBold !bg-main-background-card !p-2 !text-main-foreground-primary',
    'hover:!bg-main-background-interactive-list-hover hover:!text-main-foreground-primary',
  ),
  {
    variants: {
      active: {
        true: '!bg-main-background-muted',
      },
      defaultVariants: {
        active: false,
      },
    },
  },
)
